import { useEffect, useState } from "react";
import { Heart } from "lucide-react";
import { useLang } from "@/i18n";
import { api, getFavorites } from "@/api";
import ItemCard from "@/components/ItemCard";
import { SectionHead } from "@/components/Widgets";

export default function Favorites() {
  const { t } = useLang();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const slugs = getFavorites();
    if (!slugs.length) {
      setLoading(false);
      return;
    }
    api.get("/items", { params: { slugs: slugs.join(","), limit: 100 } })
      .then((r) => setItems(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 sm:py-16" data-testid="favorites-page">
      <SectionHead kicker={<span className="inline-flex items-center gap-2"><Heart className="w-4 h-4 fill-terracotta" /> Follonica Like</span>} title={t("fav.title")} sub={t("fav.sub")} />
      {loading ? (
        <p className="py-20 text-center text-grafite/50">{t("common.loading")}</p>
      ) : items.length === 0 ? (
        <div className="text-center py-24" data-testid="favorites-empty">
          <Heart className="w-14 h-14 mx-auto text-sabbia mb-5" />
          <p className="font-accent text-3xl text-grafite/60 max-w-md mx-auto">{t("fav.empty")}</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((item, i) => <ItemCard key={item.slug} item={item} index={i} />)}
        </div>
      )}
    </div>
  );
}
